module.exports = "/_next/static/images/money-line-26f17d65c494140c1b35df4dee72b70c.svg";